import { matchPath } from 'react-router';

/**
 * Every solution page lives under `/:projectId/:botId`; the splat is optional.
 * It also matches first-level project pages (`/:projectId/settings/…`,
 * `/:projectId/configurations`), whose second segment is never a solution id —
 * callers compare the id with the draft's owner, so those never open a session.
 */
const SOLUTION_SCOPE = '/:projectId/:botId/*';
const WORKFLOWS = '/:projectId/:botId/workflows';

export const solutionIdInPath = (pathname: string): string | undefined =>
  matchPath(SOLUTION_SCOPE, pathname)?.params.botId ?? undefined;

/** The Workflows editor of a solution — the one page that shows cursors. */
export const isWorkflowsPath = (pathname: string): boolean =>
  !!matchPath(WORKFLOWS, pathname);
